@if (templateLoading()) {
  <mat-progress-spinner [diameter]="20" color="accent" mode="indeterminate" />
} @else {
  <span>{{ $safeNavigationMigration(assetTemplate()?.name) | infoDisplay }}</span>
}
